import dynamic from 'next/dynamic';

import { SimpleTitleAndTextBlockFragment } from '@hultafors/hultaforsgroup/types';

import { ContentContainer } from '../content-container/content-container';

import styles from './simple-title-and-text-block.module.scss';
import { SimpleTitleAndText } from './simple-title-and-text-block.styled';

const HTag = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.HTag),
);

export interface SimpleTitleAndTextProps
  extends Omit<SimpleTitleAndTextBlockFragment, 'id'> {
  priority?: boolean;
}

export const SimpleTitleAndTextBlock: React.FC<SimpleTitleAndTextProps> = ({
  description,
  title,
  topLabel,
  priority,
}) => {
  if (!title) {
    return null;
  }

  return (
    <ContentContainer>
      <SimpleTitleAndText>
        {topLabel && (
          <HTag
            type="p"
            styleType="sub-heading"
            className={styles['top-label']}
          >
            {topLabel}
          </HTag>
        )}
        {title && (
          <HTag type={priority ? 'h1' : 'h2'} styleType="h2">
            {title}
          </HTag>
        )}
        {description && (
          <HTag
            type="p"
            styleType="p2-paragraph"
            className={styles['description']}
          >
            {description}
          </HTag>
        )}
      </SimpleTitleAndText>
    </ContentContainer>
  );
};
